/** @jsx jsx */
import { jsx, css } from "@emotion/core";

const note = css`
 color: #040404;
`;

export default function Note(props) {
  return (
    <div css={note}>
      <p>Автор: {props.author}</p>
      <p>{props.content}</p>
    </div>
  )
}
